import { Component, OnInit, Optional } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Constantes } from '../../../shared/constant/constantes';
import { RetornoEstadisticasComponent } from '../retorno-estadisticas/retorno-estadisticas.component';
import { CommonModule } from '@angular/common';
import { VisualizadorService } from '../../../shared/service/visualizador.service';
import { environment } from '../../../../../environments/environment.development';

@Component({
    selector: 'app-menu-alterno',
    templateUrl: './menu-alterno.component.html',
    styleUrls: ['./menu-alterno.component.css'],
    standalone: true,
    providers: [VisualizadorService],
    imports: [RetornoEstadisticasComponent,CommonModule]
})
export class MenuAlternoComponent {

  currentPath: string = '';

  constructor(private service: VisualizadorService, private router: Router, @Optional() private route?: ActivatedRoute ) {
    route?.url.subscribe({
      next: url$ => {
        if (url$[0])
          this.currentPath = url$[0].path;
      }
    })    
  }

  public constantes: Constantes = new Constantes();
  //private urlBase = window.location.origin;

  public irBuscadorSeries(target?: string){
    var urlEnlace:string= environment.APP_DESCARGA_MULTIPLE_DATOS + '/#/buscador-de-series/';
    if (!target)
      target = "_self"

    this.service.windowOpen(urlEnlace, target);
  }

  public irGraficasInteractivas(target?: string){
    var urlEnlace:string= environment.APP_GRAFICADOR + '/#/graficador-series/';
    if (!target)
      target = "_self"
    this.service.windowOpen(urlEnlace, target);
  }

  public irCatalogoRecomendados(target?: string){
    this.router.navigate([this.constantes.ROUTE_CATALOGO]);
  }

  public irTablasPreconstruidas(target?: string){
    this.router.navigate([this.constantes.ROUTE_TABLAS_PRECONSTRUIDAS]);
  }

  public irIndicadoresEconomicosDia(target?: string){
    var urlEnlace:string= environment.APP_INDICADORES_ECONOMICOS_DIA + '/#/indicadores-economicos-del-dia/';
    if (!target)
      target = "_self"
    this.service.windowOpen(urlEnlace, target);
  }
  

}
